














































































































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import InteractiveData from '@/components/question/interactive_data/InteractiveData.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxTooltip from '@/dex-shared/components/px-tooltip.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import VideoShow from '@/dex-shared/components/content/show/VideoShow.vue';
import KalturaVideoShow from '@/dex-shared/components/new_content/show/KalturaVideoShow.vue';

export default Vue.extend({
  components: {
    Content,
    InteractiveData,
    pxCard,
    pxButton,
    pxTooltip,
    Loading,
    SquareEditOutlineIcon,
    ArrowRightIcon,
    PlusIcon,
    CloseIcon,
    VideoShow,
    KalturaVideoShow,
  },

  data() {
    return {
      loaded: true,
      openedSelectorIndex: -1,
      generatingPdf: false,
    };
  },
  computed: {
    ...mapGetters({
      list: 'currentList',
    }),
    ...mapState({
      boards: (state: any) => state.boards.boards,
      boardSections: (state: any) => state.boardSections.board_sections,
      boardSubsections: (state: any) =>
        state.boardSubsections.board_subsections,
      pdfLink: (state: any) => state.lists.pdfLink,
    }),
  },
  async created() {
    let listId, listSlug;
    if (isNaN(this.$route.params.listId)) {
      listSlug = this.$route.params.listId;
    } else {
      listId = +this.$route.params.listId;
    }
    this.loaded = false;
    this.$store.commit('SET_PDF_LINK', null);
    await this.$store.dispatch('PULL_LIST', { listId, listSlug });
    this.$router.push(`/lista/${this.list.id}`);
    this.loaded = true;
    await this.$store.dispatch('PULL_BOARDS');
    await this.$store.dispatch('PULL_BOARD_SECTIONS');
    await this.$store.dispatch('PULL_BOARD_SUBSECTIONS');
  },

  methods: {
    openItem(item: any) {
      let path = '';
      if (item.__typename === 'Article') {
        path = 'explicacao';
      } else if (item.__typename === 'Question') {
        path = 'questao';
      }
      let route = this.$router.resolve({
        path: `/${path}/${item.id}`,
      });
      window.open(route.href, '_blank');
    },
    openSelector: function(index: number) {
      if (index == this.openedSelectorIndex) {
        this.openedSelectorIndex = -1;
      } else {
        this.openedSelectorIndex = index;
      }
    },
    addMaterial: async function(data: any) {
      await this.$store.dispatch('ADD_MATERIAL', data);
      let listId = parseInt(this.$route.params.listId);
      await this.$store.dispatch('PULL_LIST', { listId });
    },
    removeMaterial: async function(materialId: number) {
      if (confirm('Tem certeza?')) {
        await this.$store.dispatch('REMOVE_MATERIAL', materialId);
        let listId = parseInt(this.$route.params.listId);
        await this.$store.dispatch('PULL_LIST', { listId });
      }
    },
    generatePDF: async function() {
      let listId = parseInt(this.$route.params.listId);
      this.generatingPdf = true;
      await this.$store.dispatch('GENERATE_PDF', listId);
      this.generatingPdf = false;
    },
    videoDuration: function(duration: number) {
      return duration
        ? ` ${Math.trunc(duration / 60)}
        minuto(s) e 
        ${duration % 60}
        segundo(s)`
        : '-';
    },
  },
});
